import {StateFilter} from '../Store/State';

/**
 * Сформировать из текущего состояния фильтра строку запроса.
 * 
 * @param state Объект состояния
 */
function listStateToQueryString( filter: StateFilter, nextItemsOffset?: number ): string
{
	const queryParts: string[] = [
		'mode=list',
	];
	
	if ( typeof nextItemsOffset !== 'undefined' )
	{
		queryParts.push( 'offset=' + nextItemsOffset );
	}
	
	for ( const checkbox of filter.section )
	{
		if ( checkbox.checked )
		{
			queryParts.push( 'section[]=' + encodeURIComponent( checkbox.value ) );
		}
	}
	
	for ( const checkbox of filter.roomType )
	{
		if ( checkbox.checked )
		{
			queryParts.push( 'roomType[]=' + encodeURIComponent( checkbox.value ) );
		}
	}
	
	if ( filter.floor.from !== filter.floor.min )
	{
		queryParts.push( 'floorFrom=' + String( filter.floor.from ) );
	}
	
	if ( filter.floor.to !== filter.floor.max )
	{
		queryParts.push( 'floorTo=' + String( filter.floor.to ) );
	}
	
	if ( filter.squareTotal.from !== filter.squareTotal.min )
	{
		queryParts.push( 'squareTotalFrom=' + String( filter.squareTotal.from ) );
	}
	
	if ( filter.squareTotal.to !== filter.squareTotal.max )
	{
		queryParts.push( 'squareTotalTo=' + String( filter.squareTotal.to ) );
	}
	
	if ( filter.totalCost.from !== filter.totalCost.min )
	{
		queryParts.push( 'totalCostFrom=' + String( filter.totalCost.from ) );
	}
	
	if ( filter.totalCost.to !== filter.totalCost.max )
	{
		queryParts.push( 'totalCostTo=' + String( filter.totalCost.to ) );
	}
	
	return queryParts.join( '&' );
}

/**
 * Module
 */
export {
	listStateToQueryString as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/utils/listStateToQueryString.ts